import { IllustrationProps } from 'fe-design-base/assets/types';
import Box from 'fe-design-base/atoms/Box';

import celebration_hooray_banner from './imageFiles/celebration_hooray_banner.png';

const CelebrationHoorayBanner = (props: IllustrationProps) => (
  <Box
    w={72}
    {...props}
    minw={72}
    className={`FDBIllustration${
      props?.className ? ` ${props.className}` : ''
    }`}
  >
    <img
      src={celebration_hooray_banner}
      style={{ width: '100%' }}
      alt="Celebration Hooray Banner Illustration"
    />
  </Box>
);
export default CelebrationHoorayBanner;
